import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import classNames from 'classnames'

import styles from '../component-styles/acquisition-actions.module.scss'
import Button from './button'
import { SelectBoxButton } from './select-box'
import { requestFeature } from '../api-client/support-client'
import { getCampaignLinkRawData } from '../api-client/graphql-client'
import { logActionAsync } from '../store/actions'
import { Preloader } from './loader'

interface AcquisitionActionsProps {
  selectedDimensions: any
  currentDate: string
  startDate: Date
  endDate: Date
  granularity: string
  selectedMetric: string
  stackDimension: string
  className?: string
  onEditMetric?: () => void
  children?: any
}

export default function AcquisitionActions({
  selectedDimensions,
  startDate,
  currentDate,
  endDate,
  granularity,
  selectedMetric,
  stackDimension,
  className,
  onEditMetric,
  children,
}: AcquisitionActionsProps): React.ReactElement {
  const [exporting, setExporting] = useState(false)
  const dispatch = useDispatch()

  return (
    <SelectBoxButton
      value="Actions"
      className={classNames(className, styles.bulkButtons)}
      action
      onClick={(active) => {
        if (active) {
          const actionData = {
            action: 'action-drop-down-clicked',
            longDescription: '',
            websiteSection: 'report',
          }
          dispatch(logActionAsync(actionData))
        }
      }}
    >
      <>
        <Button
          disabled
          type="selectBox"
          onClick={async () => {
            const message = `Perfomance dashboard "Create insight" feature request`
            await requestFeature({
              page: 'report/performance',
              message,
            })
          }}
        >
          Create insight
        </Button>
        <Button type="selectBox" disabled>
          Download as PDF
        </Button>
        <Button
          type="selectBox"
          disabled={exporting}
          onClick={async (e) => {
            e.preventDefault()
            e.stopPropagation()
            setExporting(true)
            const data = Object.keys(selectedDimensions).map(
              (dimensionName) => {
                return {
                  dimensionName,
                  dimensionOptions: [...selectedDimensions[dimensionName]],
                }
              },
            )
            const from =
              currentDate === 'custom'
                ? moment(startDate).format('YYYY-MM-DD')
                : currentDate
            const to =
              currentDate === 'custom'
                ? moment(endDate).format('YYYY-MM-DD')
                : currentDate
            const rawExcelData = {
              startDate: from,
              endDate: to,
              granularity,
              selectedMetric,
              stackDimension,
              matchType: 'full',
              applyFilters: [...data],
            }
            await getCampaignLinkRawData(rawExcelData)
            const actionData = {
              action: 'download-data-excel',
              longDescription: JSON.stringify(rawExcelData),
              websiteSection: 'report',
            }
            dispatch(logActionAsync(actionData))
            setExporting(false)
          }}
        >
          <div className={styles.excelDownload}>
            {exporting && (
              <Preloader style={{ width: 24, height: 16, margin: '6px 0' }} />
            )}
            {exporting ? 'Downloading' : 'Download to Excel'}
          </div>
        </Button>
        <Button
          disabled
          type="selectBox"
          onClick={async () => {
            const message = `Perfomance dashboard "Share" feature request`
            await requestFeature({
              page: 'report/performance',
              message,
            })
          }}
        >
          Share
        </Button>
        {onEditMetric && (
          <Button
            type="selectBox"
            onClick={() => {
              onEditMetric()
            }}
          >
            Edit metrics
          </Button>
        )}
        {children}
      </>
    </SelectBoxButton>
  )
}
